import { render, staticRenderFns } from "./WarningInfo.vue?vue&type=template&id=4e32877e&scoped=true"
import script from "./WarningInfo.vue?vue&type=script&lang=js"
export * from "./WarningInfo.vue?vue&type=script&lang=js"
import style0 from "./WarningInfo.vue?vue&type=style&index=0&id=4e32877e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32877e",
  null
  
)

export default component.exports